module.exports = __webpack_public_path__ + "img/head.ac5c024b.png";